import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';

import './index.scss';

const { Office } = window;
const container = document.getElementById('root');
const root = createRoot(container);

Office.onReady(() => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>,
  );
});

if (module.hot) {
  module.hot.accept();
}
